import { SidebarItem } from '@backstage/core-components';
import DeveloperModeIcon from '@material-ui/icons/DeveloperMode';
import { useDevToolsAuthorization } from './useDevToolsAuthorization';

export const AuthorizedDevToolsSidebarItem = () => {
  const { isLoading, isAuthorized } = useDevToolsAuthorization();

  // Don't render anything while loading or if not authorized
  if (isLoading || !isAuthorized) {
    return null;
  }

  // Render the Dev Tools sidebar item for authorized users
  return <SidebarItem icon={DeveloperModeIcon} to="dev-tools" text="Dev Tools" />;
};
